"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.focusBoxShadow = exports.getTextColor = exports.createTheme = void 0;
var emotion_1 = require("emotion");
var createBreakpoints_1 = require("./createBreakpoints");
var createPallete_1 = require("./createPallete");
var createShadows_1 = require("./createShadows");
var createTypography_1 = require("./createTypography");
var radius_1 = require("./radius");
var zIndex_1 = require("./zIndex");
exports.createTheme = function (config) {
    if (config === void 0) { config = {}; }
    var pallete = createPallete_1.createPallete(config.pallete);
    var typography = createTypography_1.createTypography(pallete, config.typography);
    return {
        pallete: pallete,
        typography: typography,
        breakpoints: createBreakpoints_1.createBreakpoints(),
        zIndex: zIndex_1.zIndex,
        radius: radius_1.radius,
        shadows: createShadows_1.createShadows(),
        animation: {
            spinAround: emotion_1.keyframes({
                from: {
                    transform: 'rotate(0deg)',
                },
                to: {
                    transform: 'rotate(359deg)',
                },
            }),
        },
    };
};
exports.getTextColor = function (theme, color) {
    return createPallete_1.textColorMap[color](theme.pallete);
};
exports.focusBoxShadow = function (theme, color, type) {
    if (color === void 0) { color = 'primary'; }
    if (type === void 0) { type = 'double'; }
    var c = exports.getTextColor(theme, color);
    if (type === 'single') {
        return "0 0 0 2px " + c;
    }
    else if (type === 'inset') {
        return "inset 0 0 0 2px " + c;
    }
    else {
        return "0 0 0 2px " + theme.pallete.surface.background + ", 0 0 0 4px " + c;
    }
};
//# sourceMappingURL=createTheme.js.map